import { Component, OnInit, Input, EventEmitter, Output, Renderer, } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Pagination } from '../../../models/pagination';
import { Router } from '@angular/router';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { RetencionDetalle } from '../../../models/retencion_detalle';

@Component({
	selector: 'retencion-renta-modal',
	templateUrl: './retencion-renta-modal.component.html',
    styleUrls: ['./retencion-renta-modal.component.css'],
})
export class RetencionRentaModalComponent implements OnInit {
    @Input() impuesto_porcentaje_renta: any;
    @Output() sendImpuestoRenta = new EventEmitter();
    
    public selectedRow: Number;
    public pagination: Pagination;
    public loading = false;
    public retencionDetalle: RetencionDetalle;
    public impuesto_renta: Array<any>;
    public impuesto_busqueda: Array<any>;
    public current_page: number;
    public last_page: number;
    public sobrante: number;
    public from: number;
    public to: number;
    constructor(
        public bsModalRef: BsModalRef,
        private NavRoute: Router,
		private storage: AsyncLocalStorage,
		private render: Renderer,
    ){
        this.pagination = new Pagination();
        this.current_page = 1;
        this.impuesto_busqueda = [];
        this.from = 1;
        this.to = 10;
        
    }

    ngOnInit(){
        // this.impuesto_renta = this.impuesto_porcentaje_renta;
        this.last_page = this.impuesto_porcentaje_renta.length / 10;
        this.sobrante = this.impuesto_porcentaje_renta.length % 10;
        this.getImpuestos(this.from,this.to);
    }

    getImpuestoRentaBySearch(text){
       this.pagination.current_page = 1;
       this.from = 1;
        this.to = 10;
        this.impuesto_busqueda = this.impuesto_porcentaje_renta.filter(x => {
            if(x.codigo.toLowerCase().includes(text.toLowerCase()) || x.descripcion.toLowerCase().includes(text.toLowerCase())) return x;
        });

        if(text !=''){
            this.last_page = this.impuesto_busqueda.length / 10;
            this.sobrante = this.impuesto_busqueda.length % 10;
        }else{
            this.last_page = this.impuesto_porcentaje_renta.length / 10;
            this.sobrante = this.impuesto_porcentaje_renta.length % 10;
        }
        this.getImpuestos(this.from,this.to);
    }

	onSelectRow(impuesto_renta, i) {
		//Asignacion de fila
		this.selectedRow = i;
		//Asignacion de proveedor
		this.retencionDetalle = impuesto_renta;
	}

	onDBLClick(impuesto_renta,i)
	{
		this.onSelectRow(impuesto_renta,i);
		this.onSubmit();
    }

    getImpuestos(from, to){
        return new Promise((resolve, reject)=>{
            if(this.impuesto_porcentaje_renta.length > 10){
                
                this.impuesto_renta = this.impuesto_busqueda.length > 0?this.impuesto_busqueda.slice(from-1, to):this.impuesto_porcentaje_renta.slice(from - 1, to);
                this.pagination.from = from;
                this.pagination.to = to;
                this.pagination.total = this.impuesto_busqueda.length > 0 ? this.impuesto_busqueda.length:this.impuesto_porcentaje_renta.length;
                this.pagination.last_page = Math.ceil(this.last_page);
                this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
                this.pagination.prev_disabled = this.pagination.current_page === 1;
                resolve(true);
            }else{
                this.impuesto_renta = this.impuesto_busqueda.length > 0 ? this.impuesto_busqueda:this.impuesto_porcentaje_renta;
            }
           
        });
        
    }

    getIndexNumber(i) {
		return this.pagination.from + i;
     }
    
    next(){
        this.loading = true;
        this.pagination.current_page++;
        this.from += 10;
        if(this.pagination.current_page == this.pagination.last_page){
            this.to = this.pagination.total;
        }else{
            this.to += 10; 
        }
        
        this.getImpuestos(this.from, this.to).then(
          res => this.loading = false,
          err => this.loading = false,
        );
    }

    prev(){
        this.loading = true;
        
        this.pagination.current_page--;
        this.from -= 10;
        if(this.pagination.current_page == this.pagination.last_page && this.sobrante > 0){
            this.to = this.pagination.total - this.sobrante;
        }else{
            
            this.to -= 10;
        }
        
        this.getImpuestos(this.from,this.to).then(
            res => this.loading = false,
            err => this.loading = false,
        );
    }

    first(){
        this.loading = true;
        this.pagination.current_page = 1;
        this.from = 1;
        this.to= 10;
        this.getImpuestos(this.from, this.to).then(
            res => this.loading = false,
            err => this.loading = false,
        );
    }

    last(){
        this.loading = true;
        this.pagination.current_page = this.pagination.last_page;
        
        if(this.sobrante > 0){
            this.from = this.pagination.total - this.sobrante;
        }else{
            this.from = this.pagination.total - 10;
            
        }
        this.to = this.pagination.total;
        this.getImpuestos(this.from, this.to).then(
            res => this.loading = false,
            err => this.loading = false,
        );
    }

	onSubmit() {
		//envía de objecto proveedor
		this.sendImpuestoRenta.emit(this.retencionDetalle);
		//Cierre de modal o componente
		this.bsModalRef.hide();
	}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/retencion-renta-modal/retencion-renta-modal.component.ts